import GESA from "@/assets/gesa_logo.svg";
import { cn } from "@/shared/lib/utils";

export function Logo({ className }: { className?: string }) {
  return <img src={GESA} alt="LOGO" className={cn("h-8", className)} />;
}
